<template>
  <section
    id="hero"
    class="content h-[calc(100vh-100px)] flex items-center justify-between relative max-md:flex-col max-md:gap-[20px]"
  >
    <img
      src="../assets/images/bg-tablet-pattern.svg"
      alt="bg"
      class="bg-section absolute top-[-190px] right-[-300px] z-[-1]"
    />

    <article
      class="info flex flex-col gap-[35px] items-start flex-[450px] max-md:items-center max-md:text-center"
    >
      <h1 class="text-5xl leading-tight font-[700] max-md:text-[2.5rem]">
        Bring everyone together to build better products.
      </h1>
      <p class="w-[350px]">
        Manage makes it simple for software teams to plan day-to-day tasks while
        keeping the larger team goals in view.
      </p>
      <button class="btn-style">Get Started</button>
    </article>
    <article
      class="image flex-[calc(100%-450px)] flex justify-end max-md:order-[-1] sm:w-[400px]"
    >
      <img src="../assets/images/illustration-intro.svg" alt="hero" />
    </article>
  </section>
</template>
